import { useEffect, useState } from 'react'

const useActiveHash = itemIds => {
	let hash = ''

	if (typeof window !== 'undefined') {
		hash = window.location.hash ?? ''
	}

	const [activeHash, setActiveHash] = useState(hash)

	useEffect(() => {
		const handleScroll = () => {
			const items = itemIds.map(id => document.getElementById(id)).filter(Boolean)

			if (items.length === 0) {
				return
			}

			if (window.innerHeight + window.scrollY <= 20) {
				// Beginning of scroll - Select first one

				setActiveHash(items[0].id)
				return
			}

			if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 20) {
				// End of scroll - Select last one

				setActiveHash(items[items.length - 1].id)
				return
			}

			let nextItemIndex = items.findIndex(item => {
				const { y, height } = item.getBoundingClientRect()
				return window.scrollY + y - height - 150 > window.scrollY
			})

			if (nextItemIndex === -1) {
				nextItemIndex = items.length
			}

			const previousItemIndex = Math.max(0, nextItemIndex - 1)

			const previousItem = items[previousItemIndex]

			setActiveHash(previousItem.id)
		}

		handleScroll()
		window.addEventListener('scroll', handleScroll)

		return () => window.removeEventListener('scroll', handleScroll)
	}, [itemIds])

	return activeHash
}

export default useActiveHash
